(() => {
  const root = document.querySelector('[data-pw-aurora]');
  if (!root || root.dataset.initialised === 'true') return;
  root.dataset.initialised = 'true';
  const dialog = root.querySelector('[role="dialog"]');
  const form = root.querySelector('#PolewardAuroraForm');
  const birthdayYear = form.querySelector('[data-pw-birthday-year]');
  const birthdayMonth = form.querySelector('[data-pw-birthday-month]');
  const birthdayDay = form.querySelector('[data-pw-birthday-day]');
  const birthdaySkip = form.querySelector('[data-pw-birthday-skip]');
  const birthdayDetails = form.querySelector('[data-pw-birthday-details]');
  let birthdayConsentChoice = null;
  const contactTags = form.querySelector('input[name="contact[tags]"]');
  const baseTags = contactTags?.value.split(',').map((tag) => tag.trim()).filter((tag) => tag && !tag.startsWith('poleward-birthday-')) || [];
  const readBirthday = () => {
    if (birthdayDetails?.hidden) return null;
    const year = Number(birthdayYear?.value);
    const month = Number(birthdayMonth?.value);
    const day = Number(birthdayDay?.value);
    const today = new Date();
    if (!Number.isInteger(year) || year < 1900 || year > today.getFullYear() || !Number.isInteger(month) || month < 1 || month > 12 || !Number.isInteger(day) || day < 1 || day > new Date(Date.UTC(year, month, 0)).getUTCDate()) return null;
    if (new Date(year, month - 1, day) > today) return null;
    return { year, month, day, consent: birthdayConsentChoice ?? true };
  };
  const writeBirthdayTags = () => {
    const birthday = readBirthday();
    if (contactTags) {
      const tags = [...baseTags];
      if (birthday) {
        tags.push('poleward-birthday-v2:' + birthday.year + '-' + String(birthday.month).padStart(2, '0') + '-' + String(birthday.day).padStart(2, '0'));
        if (birthday.consent) tags.push('poleward-birthday-note-v1');
      }
      contactTags.value = tags.join(',');
    }
    return birthday;
  };
  const syncBirthdayFields = () => {
    if (!birthdayYear || !birthdayMonth || !birthdayDay) return;
    const year = Number(birthdayYear.value) || 2000;
    const month = Number(birthdayMonth.value);
    const max = month >= 1 && month <= 12 ? new Date(Date.UTC(year, month, 0)).getUTCDate() : 31;
    birthdayDay.disabled = !month;
    [...birthdayDay.options].forEach((option) => { option.disabled = Number(option.value) > max; });
    if (Number(birthdayDay.value) > max || !month) birthdayDay.value = '';
    const inputs = [birthdayYear, birthdayMonth, birthdayDay];
    inputs.forEach((input) => input.setCustomValidity(''));
    if (!birthdayDetails?.hidden && inputs.some((input) => input.value)) {
      const missing = inputs.find((input) => !input.value);
      if (missing) missing.setCustomValidity(root.dataset.birthdayIncomplete || 'Choose your birth year, month and day, or select Skip.');
      else if (!readBirthday()) birthdayDay.setCustomValidity(root.dataset.birthdayInvalid || 'Choose a valid date of birth that is not in the future.');
    }
    writeBirthdayTags();
  };
  const setBirthdayExpanded = (expanded) => {
    if (!birthdayDetails || !birthdaySkip) return;
    birthdayDetails.hidden = !expanded;
    birthdaySkip.setAttribute('aria-expanded', String(expanded));
    birthdaySkip.textContent = expanded ? birthdaySkip.dataset.skipLabel : birthdaySkip.dataset.addLabel;
  };
  [birthdayYear, birthdayMonth, birthdayDay].forEach((input) => input?.addEventListener('change', () => {
    syncBirthdayFields();
  }));
  birthdaySkip?.addEventListener('click', () => {
    if (birthdayDetails?.hidden) {
      setBirthdayExpanded(true);
      birthdayYear?.focus();
      return;
    }
    birthdayYear.value = '';
    birthdayMonth.value = '';
    birthdayDay.value = '';
    birthdayConsentChoice = null;
    setBirthdayExpanded(false);
    syncBirthdayFields();
  });
  syncBirthdayFields();
  const fields = root.querySelector('[data-pw-aurora-fields]');
  const success = root.querySelector('[data-pw-aurora-success]');
  const error = root.querySelector('[data-pw-aurora-error]');
  const status = root.querySelector('[data-pw-aurora-status]');
  const cookieStatus = root.querySelector('[data-pw-cookie-status]');
  const cookieInputs = [...root.querySelectorAll('[data-pw-consent]')];
  const cookieButtons = [...root.querySelectorAll('[data-pw-cookie-save]')];
  const cookieDetails = root.querySelector('[data-pw-cookie-details]');
  const keys = { dismissed: 'pw-aurora-dismissed-v1', pending: 'pw-aurora-pending-v1', subscribed: 'pw-aurora-subscribed-v1', draft: 'pw-aurora-draft-v1' };
  const storage = (method, key, value) => {
    try { return window.sessionStorage[method](key, value); } catch (_) { return null; }
  };
  let privacyPromise;
  let previousFocus;
  let resetTimer;
  let autoTimer;
  const isUnsubscribePage = /^(?:\/[^/]+)?\/account\/unsubscribe\/?$/.test(window.location.pathname);
  let pendingCookieSave = false;
  let dismissalRecorded = false;
  const setPrivacyReady = (ready) => {
    document.documentElement?.classList.toggle('pw-aurora-privacy-ready', ready);
  };
  const hasFreshIntent = () => {
    const timestamp = Number(storage('getItem', keys.pending));
    return timestamp > 0 && Date.now() - timestamp < 30 * 60 * 1000;
  };
  const ownsFormResponse = hasFreshIntent();
  const confirmed = Boolean(success && ownsFormResponse);
  if (!hasFreshIntent()) storage('removeItem', keys.draft);
  const recordDismissal = () => {
    dismissalRecorded = true;
    storage('setItem', keys.dismissed, String(Date.now()));
  };
  const loadPrivacy = () => {
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) return Promise.resolve(window.Shopify.customerPrivacy);
    if (privacyPromise) return privacyPromise;
    privacyPromise = new Promise((resolve, reject) => {
      const deadline = Date.now() + 10000;
      const attempt = () => {
        if (window.Shopify?.customerPrivacy?.setTrackingConsent) return resolve(window.Shopify.customerPrivacy);
        if (typeof window.Shopify?.loadFeatures === 'function') {
          const timeout = setTimeout(() => reject(new Error('privacy-timeout')), 10000);
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (loadError) => {
            clearTimeout(timeout);
            if (loadError || !window.Shopify?.customerPrivacy?.setTrackingConsent) reject(new Error('privacy-unavailable'));
            else resolve(window.Shopify.customerPrivacy);
          });
        } else if (Date.now() < deadline) setTimeout(attempt, 200);
        else reject(new Error('privacy-unavailable'));
      };
      attempt();
    }).catch((loadError) => {
      privacyPromise = null;
      throw loadError;
    });
    return privacyPromise;
  };
  const syncCookieInputs = (api) => {
    const consent = api.currentVisitorConsent();
    cookieInputs.forEach((input) => { input.checked = consent[input.dataset.pwConsent] === 'yes'; });
  };
  const loadCookiePanel = async () => {
    cookieStatus.textContent = root.dataset.cookieLoading;
    cookieInputs.forEach((input) => { input.disabled = true; });
    try {
      const api = await loadPrivacy();
      if (!pendingCookieSave) syncCookieInputs(api);
      cookieStatus.textContent = '';
      setPrivacyReady(true);
    } catch (_) {
      setPrivacyReady(false);
      cookieStatus.textContent = root.dataset.cookieError;
    } finally {
      if (!pendingCookieSave) cookieInputs.forEach((input) => { input.disabled = false; });
    }
  };
  const focusables = () => [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex="0"]')].filter((node) => node.getClientRects().length > 0);
  const open = (mode = 'offer', trigger) => {
    clearTimeout(autoTimer);
    if (root.hidden) previousFocus = trigger || document.activeElement;
    root.classList.toggle('pw-aurora--cookies', mode === 'cookies');
    root.hidden = false;
    dialog.setAttribute('aria-labelledby', mode === 'cookies' ? 'AuroraCookieHeading' : 'PolewardAuroraHeading');
    document.body.classList.add('pw-aurora-is-open');
    dialog.scrollTop = 0;
    if (mode === 'cookies') cookieDetails.open = true;
    const focusTarget = mode === 'cookies' ? root.querySelector('#AuroraCookieHeading') : confirmed ? success : dialog;
    focusTarget.focus({ preventScroll: true });
    loadCookiePanel();
    recordDismissal();
  };
  const close = () => {
    root.hidden = true;
    document.body.classList.remove('pw-aurora-is-open');
    recordDismissal();
    storage('removeItem', keys.draft);
    if (previousFocus?.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
  };
  const saveCookies = async (mode) => {
    if (pendingCookieSave) return;
    pendingCookieSave = true;
    cookieButtons.forEach((button) => { button.disabled = true; });
    cookieStatus.textContent = root.dataset.cookieLoading;
    const wanted = Object.fromEntries(cookieInputs.map((input) => [input.dataset.pwConsent, mode === 'accept' || (mode === 'selected' && input.checked)]));
    try {
      const api = await loadPrivacy();
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('privacy-save-timeout')), 10000);
        api.setTrackingConsent(wanted, () => {
          clearTimeout(timeout);
          const saved = api.currentVisitorConsent();
          if (Object.entries(wanted).every(([key, value]) => saved[key] === (value ? 'yes' : 'no'))) resolve();
          else reject(new Error('privacy-not-saved'));
        });
      });
      syncCookieInputs(api);
      setPrivacyReady(true);
      cookieStatus.textContent = root.dataset.cookieSaved;
      cookieDetails.open = false;
    } catch (_) {
      setPrivacyReady(false);
      cookieStatus.textContent = root.dataset.cookieError;
    } finally {
      pendingCookieSave = false;
      cookieInputs.forEach((input) => { input.disabled = false; });
      cookieButtons.forEach((button) => { button.disabled = false; });
    }
  };
  document.addEventListener('click', (event) => {
    const cookieTrigger = event.target.closest('[data-pw-cookie-open]');
    const newsletterTrigger = event.target.closest('[data-pw-aurora-open]');
    if (cookieTrigger || newsletterTrigger) {
      event.preventDefault();
      open(cookieTrigger ? 'cookies' : 'offer', cookieTrigger || newsletterTrigger);
    }
  });
  root.addEventListener('click', (event) => {
    if (event.target === root || event.target.closest('[data-pw-aurora-close]')) close();
    const saveButton = event.target.closest('[data-pw-cookie-save]');
    if (saveButton) saveCookies(saveButton.dataset.pwCookieSave);
  });
  document.addEventListener('keydown', (event) => {
    if (root.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const active = document.activeElement;
    if (active?.tagName === 'IFRAME' && !root.contains(active)) return;
    const items = focusables();
    const first = items[0];
    const last = items.at(-1);
    if (!first) { event.preventDefault(); dialog.focus(); return; }
    if (event.shiftKey && (active === first || !root.contains(active) || active === dialog)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (active === last || !root.contains(active))) { event.preventDefault(); first.focus(); }
  });
  const nameInputs = [...form.querySelectorAll('input[autocomplete="given-name"], input[autocomplete="family-name"]')];
  nameInputs.forEach((input) => input.addEventListener('input', () => input.setCustomValidity('')));
  form.addEventListener('submit', (event) => {
    nameInputs.forEach((input) => { input.value = input.value.trim(); });
    if (nameInputs.some((input) => !input.value)) {
      event.preventDefault();
      form.reportValidity();
      return;
    }
    syncBirthdayFields();
    if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
    storage('setItem', keys.pending, String(Date.now()));
    storage('setItem', keys.draft, JSON.stringify({ at: Date.now(), names: nameInputs.map((input) => input.value), birthday: writeBirthdayTags(), birthdaySkipped: birthdayDetails?.hidden === true }));
    status.textContent = root.dataset.submitPending;
    clearTimeout(resetTimer);
    resetTimer = setTimeout(() => { status.textContent = ''; }, 30000);
  });
  window.addEventListener('pageshow', () => { status.textContent = ''; });
  document.addEventListener('visitorConsentCollected', () => {
    if (!root.hidden && !pendingCookieSave && window.Shopify?.customerPrivacy) syncCookieInputs(window.Shopify.customerPrivacy);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.contains(root)) { clearTimeout(autoTimer); clearTimeout(resetTimer); document.body.classList.remove('pw-aurora-is-open'); setPrivacyReady(false); }
  });
  if (confirmed && !isUnsubscribePage) {
    fields.hidden = true;
    success.hidden = false;
    storage('removeItem', keys.pending);
    storage('removeItem', keys.draft);
    storage('setItem', keys.subscribed, String(Date.now()));
    open();
  } else if (error && ownsFormResponse && !isUnsubscribePage) {
    try {
      const draft = JSON.parse(storage('getItem', keys.draft));
      if (draft && Date.now() - draft.at < 30 * 60 * 1000 && Array.isArray(draft.names)) {
        nameInputs.forEach((input, index) => {
          if (!input.value && typeof draft.names[index] === 'string') input.value = draft.names[index].slice(0, 100);
        });
        if (birthdayYear && birthdayMonth && birthdayDay && draft.birthday && Number.isInteger(draft.birthday.year) && Number.isInteger(draft.birthday.month) && Number.isInteger(draft.birthday.day)) {
          birthdayYear.value = String(draft.birthday.year);
          birthdayMonth.value = String(draft.birthday.month);
          birthdayDay.value = String(draft.birthday.day);
          birthdayConsentChoice = draft.birthday.consent === true;
          syncBirthdayFields();
        }
        if (draft.birthdaySkipped === true && !readBirthday()) {
          setBirthdayExpanded(false);
          syncBirthdayFields();
        }
      }
    } catch (_) {}
    storage('removeItem', keys.draft);
    open();
    error.focus?.({ preventScroll: true });
  } else if (!isUnsubscribePage && root.dataset.editor !== 'true' && root.dataset.subscribed !== 'true' && !storage('getItem', keys.dismissed) && !storage('getItem', keys.subscribed)) {
    autoTimer = setTimeout(() => {
      if (dismissalRecorded || document.hidden || document.querySelector('dialog[open], details.menu-opening')) return;
      open();
    }, 5000);
  }
  if (root.hidden) loadCookiePanel();
})();
